module.exports = __webpack_public_path__ + "static/media/team-health-pool-flyer.0195273d.jpg";